import { BUILDINGS } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const BuildingsExporter = createExporter(`administration_${BUILDINGS}.xlsx`,
    [
        { key: "nameBg", label: "име на български език" },
        { key: "nameEn", label: "име на английски език" },
        { key: "address", label: "адрес" }, 
        { key: "latitude", label: "географска ширина" }, 
        { key: "longitude", label: "географска дължина" },
    ],
        (record) => ({
            ...record,
    })
);